document.addEventListener('DOMContentLoaded', function () {

const alrIds = [];

function isMobile() {
  return window.matchMedia('(max-width: 749px)').matches;
}

function injectAliReviewsCSS() {
  const styleId = 'alireviews-custom-style';

  if (document.getElementById(styleId)) return;

  const style = document.createElement('style');
  style.id = styleId;
  style.type = 'text/css';

  style.textContent = `
    .alireviews-review-box.alr-template-grid .alr-wh-comp-review-rating-verify {
      background-color: white!important;
      padding: 0!important;
    }

    .alireviews-review-box .alr-wh-comp-verify-purchase {
        margin-left: 0px!important;
    }

    .alireviews-review-box .alr-wh-comp-review-account-country-wrap {
      max-width: fit-content!important;
      margin-right: 10px!important;
    }

    @media (max-width: 767px) {
        .alireviews-review-box-mobile .alr-wh-comp-review-account{
            flex-direction: column!important;
        }

        .alireviews-review-box-mobile .alr-wh-comp-review-rating-verify {
            margin-top: .5rem!important;
        }

      .alireviews-review-box.alireviews-review-box-mobile .alr-wh-comp-summary-average-header {
            display: none!important;
      }
        .alr-wh-comp-filter-buttons-write-review {
            border: 1px solid var(--alr-wh-range_question_border_color) !important;
        }

        .alr-wh-comp-filter-buttons-write-review p {
            font-weight: 400!important;
        }

        .alireviews-review-box .alr-wh-comp-review-filter-left {
            display: flex!important;
            justify-content: space-between!important;
        }
    }
  `;

  document.head.appendChild(style);
}

function updateReviewItems() {
    const reviewItems = document.querySelectorAll('.alr-wh-comp-review-listing-item');

    if (!reviewItems.length) return;

    reviewItems.forEach(item => {
        const textContentEl = item.querySelector('.alr-wh-comp-text-content');
        const itemId = textContentEl.dataset.alrId;
        /* Save and mark the updated elements */
        if (textContentEl && itemId) {
            alrIds.push(itemId);
        }

        const verifyEl = item.querySelector('.alr-wh-comp-verify-purchase');
        const accountEl = item.querySelector('.alr-wh-comp-review-account');

        if (verifyEl && accountEl && !accountEl.contains(verifyEl) && alrIds.includes(itemId)) {
            accountEl.appendChild(verifyEl);
        }
    });
}

function observeReviewListing() {
    // const listingEl = document.querySelector('.alr-wh-comp-review-listing');
    const listingEl = document.querySelector('.alireviews-review-box');
    
    if (!listingEl) return;

    updateReviewItems();

    const observer = new MutationObserver(mutations => {
        for (const mutation of mutations) {
            if (mutation.type === 'childList') {
                updateReviewItems();
                break;
            }
        }
    });

    observer.observe(listingEl, {
        childList: true,
        subtree: true
    });
}

/* Handle update review box widget on mobile */
function initAliReviewsMobileStarPosition() {
  // check mobile (Shopify breakpoint)
  if (!window.matchMedia('(max-width: 749px)').matches) return;

  let hasRun = false;

  function moveStar() {
    const star = document.querySelector('.alireviews-review-box .alr-wh-rating-star-icon');
    const target = document.querySelector('.alireviews-review-box .alr-wh-comp-review-filter-left');

    if (star && target && !target.contains(star)) {
      target.prepend(star);
    }
  }

  const bodyObserver = new MutationObserver(() => {
    const reviewBody = document.querySelector('.alireviews-review-box-body');
    if (!reviewBody || hasRun) return;

    const reviewObserver = new MutationObserver(() => {
      if (hasRun) return;

      hasRun = true;
      reviewObserver.disconnect();
      bodyObserver.disconnect();

      moveStar();
    });

    reviewObserver.observe(reviewBody, {
      childList: true,
      subtree: true
    });
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });
}


// init
injectAliReviewsCSS();
observeReviewListing();
initAliReviewsMobileStarPosition();

});
